module.exports = __webpack_public_path__ + "static/media/BrownTS_2016_Academic_Manuscript.52df4c55.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/manuscript/BrownTS_2016_Academic_Manuscript.pdf
// module id = 357
// module chunks = 0